import {ButtonContainer, SubHeading, StepWrapper} from "../components/Shared";
import StyledDropdown from "../components/StyledDropdown";
import StyledButton from "../components/StyledButton";
import Tooltip from "../components/Tooltip";
import useForm from "../../utils/hooks/useForm";

const Step2 = ({prev, next}: { prev: () => void, next: () => void }) => {

    const {
        fields,
        setField,
        validateFields
    } = useForm(['mainConnection', 'cupboardLocation', 'crawlSpace', 'topFloor'])

    const submit = () => {
        !validateFields() && next()
    }

    return (
        <StepWrapper>
            <SubHeading>Hoofdaansluiting</SubHeading>

            <StyledDropdown
                onChange={({label}) => setField({key: 'mainConnection', value: label})}
                error={fields['mainConnection'].error}
                options={[
                    {label: '1 x 25A', value: 1},
                    {label: '1 x 35A / 40A', value: 2},
                    {label: '3 x 25A', value: 3},
                    {label: '3 x 35A / 40A', value: 4},
                    {label: '3 x 63A', value: 5},
                    {label: '3 x 80A', value: 6},
                    {label: '3 x 100A', value: 7}]}
                label={'Wat is de hoofdaansluiting van de groepenkast?'}/>

            <Tooltip text='Wat is de hoofdaansluiting en waar kan ik die vinden?'
                     description={'De hoofdaansluiting gaat over de capaciteit van de groepenkast. We hebben deze informatie nodig in verband met de afzekerwaarde van de omvormer; of de omvormer kan worden aangesloten met jouw huidige hoofdaansluiting. Je kunt de hoofdaansluiting opvragen bij jouw netbeheerder, bijvoorbeeld Stedin, Liander of Enexis. Let op: de aansluitwaarde op het afschrift van je energieleverancier is niet leidend over je daadwerkelijk hoofdaansluiting.'}/>

            <SubHeading>Kabeltraject</SubHeading>

            <StyledDropdown
                onChange={({label}) => setField({key: 'cupboardLocation', value: label})}
                error={fields['cupboardLocation'].error}
                options={[
                    {label: 'Bij de voordeur aan de buitenmuur gemonteerd', value: 1},
                    {label: 'Bij de voordeur aan de binnenmuur gemonteerd', value: 2},
                    {label: 'Ergens anders, namelijk ', value: 3}]}
                label={'Waar in huis bevindt zich de meterkast?'}/>

            <StyledDropdown
                onChange={({label}) => setField({key: 'crawlSpace', value: label})}
                error={fields['crawlSpace'].error}
                label={'Is er een open kruipruimte of koof beschikbaar voor de kabel  van de meterkast naar het zonnestroomsysteem?'}
                options={[
                    {label: 'Er is een open kruipruimte', value: 1},
                    {
                        label: 'Er is een beschikbare koof die begint dichtbij/ in de meterkast en loopt tot aan de bovenste verdieping ',
                        value: 2
                    },
                    {label: 'Beide zijn beschikbaar', value: 3},
                    {label: 'Beide zijn niet aanwezig/beschikbaar ', value: 4}]}/>

            <StyledDropdown
                onChange={({label}) => setField({key: 'topFloor', value: label})}
                error={fields['topFloor'].error}
                label={'Is er op de bovenste verdieping een (vrije) groep waar nu een wasmachine/droger staat of stond?'}
                options={[
                    {label: 'Ja', value: 1},
                    {label: 'Nee', value: 2},
                    {label: 'Onbekend', value: 3}]}/>


            <ButtonContainer>
                <StyledButton
                    secondary
                    onClick={() => prev()}
                    label={'Vorige \nstap'}/>

                <StyledButton
                    onClick={() => submit()}
                    label={'Volgende \nstap'}/>
            </ButtonContainer>
        </StepWrapper>
    )
}

export default Step2
